import React from 'react';

const UploadIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...rest}>
      <path d="M6.66797 26.1667C6.66797 26.4428 6.89183 26.6667 7.16797 26.6667H24.8346C25.1108 26.6667 25.3346 26.4428 25.3346 26.1667V24.5C25.3346 24.2239 25.1108 24 24.8346 24H7.16797C6.89183 24 6.66797 24.2239 6.66797 24.5V26.1667ZM7.52152 12.4798C7.20654 12.7948 7.42962 13.3333 7.87508 13.3333H11.5013C11.7774 13.3333 12.0013 13.5572 12.0013 13.8333V20.8333C12.0013 21.1095 12.2252 21.3333 12.5013 21.3333H19.5013C19.7774 21.3333 20.0013 21.1095 20.0013 20.8333V13.8333C20.0013 13.5572 20.2252 13.3333 20.5013 13.3333H24.1275C24.573 13.3333 24.7961 12.7948 24.4811 12.4798L16.3549 4.35355C16.1596 4.15829 15.843 4.15829 15.6477 4.35355L7.52152 12.4798Z" fill="#C3C5CA"/>
    </svg>
  );
};

export default UploadIcon;